import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { RootState } from '@root/app.state';

import * as PlatformActions from '@platform/platform.actions';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent implements OnInit {
  public title: string;
  public text: string;

  constructor(
    private dialogRef: MatDialogRef<InfoDialogComponent>,
    private store$: Store<RootState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.title = data.title;
    this.text = data.text;
  }

  ngOnInit(): void {}

  public onOk() {
    this.store$.dispatch(PlatformActions.closeDialog({ id: this.dialogRef.id }));
  }
}
